var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6218 25.278C17.5193 23.9458 17.5193 22.6136 17.4168 21.179C17.4168 20.4616 17.1094 19.9493 16.2896 19.9493C15.7772 19.9493 15.2648 20.0517 15.1624 19.3344C15.0599 18.4121 14.8549 17.3874 15.1624 16.4651C15.1624 16.3626 15.5723 16.1577 15.7772 16.1577C17.3144 16.4651 17.6218 15.6453 17.6218 14.4156C17.6218 11.1364 20.3886 9.3943 23.9752 9.59925C25 9.70172 25 10.5215 25 11.2389C24.8975 11.9562 25.3074 12.981 23.9752 12.981C22.848 12.8785 22.0282 13.2884 22.0282 14.6206C22.0282 15.5428 22.1307 16.2601 23.2579 16.3626C24.8975 16.4651 24.5901 17.5923 24.5901 18.7196C24.6926 19.9493 24.0777 20.3592 22.9505 20.3592C21.8233 20.3592 21.6183 20.974 21.6183 21.9988C21.6183 24.2532 21.6183 26.4052 21.5158 28.6597C21.4134 30.0943 21.1059 30.1968 19.1589 30.0943C17.8267 30.0943 17.6218 29.4795 17.7243 28.3522C17.5193 27.43 17.5193 26.4052 17.6218 25.278Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.b10961e4d21d5e9c88efa2016bc03533.svg";
export { ForwardRef as ReactComponent };